import { z } from 'zod';
import { AccountConst } from '@axiom/const';
import { SchemaDate, ZodArrayToEnum } from '@axiom/types';

export const CandidateRelationships = Object.values(
  AccountConst.CandidateRelationships
);

export const AccountBenchCandidateSchema = z.object({
  candidateId: z.string().uuid(),
  calculatedDisplayName: z.string().nullable(),
  accountRelationship: z.enum(ZodArrayToEnum(CandidateRelationships)),
  weeklyAvailability: z.number().nonnegative().nullable(),
  rolloffDate: SchemaDate.nullable(),
  profileImageKey: z.string().max(255).nullable(),
});

export type AccountBenchCandidate = z.infer<typeof AccountBenchCandidateSchema>;

export const AccountBenchResponseSchema = z.object({
  candidates: z.array(AccountBenchCandidateSchema),
});

export type AccountBenchResponse = z.infer<typeof AccountBenchResponseSchema>;
